import { apiClient } from '@/libs/axios';
import type { ApiResponse } from '@/types/api.type';
import { mutationOptions } from '@tanstack/react-query';
import type { AxiosError } from 'axios';

export type DeleteVoucherPayload = {
  voucher_id: string;
};
export type DeleteVoucherResponse = ApiResponse<null>;

export const deleteVoucher = async (
  payload: DeleteVoucherPayload
): Promise<DeleteVoucherResponse> => {
  const { voucher_id } = payload;
  const url = `voucher/${voucher_id}`;

  return await apiClient.delete(url);
};

export function deleteVoucherMutationOptions() {
  return mutationOptions<
    DeleteVoucherResponse,
    AxiosError,
    DeleteVoucherPayload
  >({
    mutationFn: deleteVoucher,
  });
}
